import styled from 'styled-components'

export const Card = styled.div`
  background-color: #ffffff;
  border-radius: 16px;
  border: 1px solid #EBEBEB;
  padding: 15px;
  width: 100%;
  margin-bottom: 1rem;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04);
`

export const ProductShort = styled.div`
  display: flex;
  align-items: center;
`

export const ProductDiv = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 20px;
  padding-left: 0.5rem;
  overflow: hidden;
`

export const Button = styled.button<{ variant?: 'primary' | 'outline' }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  border-radius: 20px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  cursor: pointer;

  ${(props) =>
    props.variant === 'primary'
      ? `
    background-color: #0090D3;
    color: #FFFFFF;
    border: none;
  `
      : `
    background-color: #FFFFFF;
    color: #0090D3;
    border: 1px solid #0090D3;
  `}
`

export const ActionsDiv = styled.div`
  display: flex;
  gap: 32px;
  padding-left: 2rem;
  margin-left: 24px;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
  background-color: #ffffff;
`

export const FormGrid = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  align-items: flex-start;
  flex-wrap: nowrap;

  & label {
    font-size: 11px !important;
    white-space: nowrap;
    margin-bottom: 4px !important;
  }
`

export const FormGroup = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Label = styled.label`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  color: #303030;
  display: flex;
  align-items: center;
  white-space: nowrap;
  gap: 8px;
`

export const Select = styled.select`
  padding: 10px 16px;
  background-color: #ebebeb;
  border: none;
  border-radius: 20px;
  color: #696969;
  font-family: 'Inter', sans-serif;
  outline: none;
`

export const SizeDiv = styled.div`
  display: flex;
  justify-content: center;
`

export const SizeLabel = styled.label`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 12px;
`

export const ColorDiv = styled.div`
  display: grid;
`

export const ColorLabel = styled.label`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 12px;
`

export const InputLabel = styled.input.attrs((props) => ({
  disabled: props.disabled,
}))`
  width: 8vw;
  height: 5.9vh;
  border-radius: 20px;
  color: #696969;
  background-color: #ebebeb;
  border: none;
  text-align: center;

  &[type='number'] {
    -webkit-appearance: textfield;
    -moz-appearance: textfield;
    appearance: textfield;
  }
  &[type='number']::-webkit-inner-spin-button,
  &[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[disabled] {
    cursor: not-allowed;
    opacity: 0.6;
  }
`

export const QuantityTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 16px;
`

export const QuantityTableWrapper = styled.div`
  width: 100%;
  max-height: none;
  overflow-x: auto;
`

export const HeaderLine = styled.tr`
  height: 4rem;
`

export const Th = styled.th`
  color: #696969;
  text-align: center;
  border: 0;
  font-size: 12px;
  font-weight: 400;
  padding: 10px 12px;
  background-color: #ffffff;
  position: sticky;
  top: 0;
  z-index: 2;
`;

export const ThFirst = styled(Th)`
  text-align: left;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 4;
  background-color: #ffffff;
`;

export const Tr = styled.tr`
  height: 4.5rem;
  background-color: #fff;
  border-bottom: solid 1px #ebebeb;
  border-radius: 1rem;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  color: #696969;

  .edit-div {
    visibility: visible;
  }
`

export const Td = styled.td`
  width: 20rem;
  text-align: start;
  font-size: 12px;
  padding-left: 1.2rem;
  white-space: nowrap;
  vertical-align: middle;

  &.check {
    width: 5rem;
    img {
      cursor: pointer;
      &.withoutCertificate {
        filter: grayscale(1);
        cursor: auto;
      }
    }
  }
`;

export const TdFirst = styled(Td)`
  background-color: #ffffff;
`;

export const TdQty = styled(Td)`
  text-align: center;
`

export const ColorRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const PricingDisplay = styled.div`
  padding: 10px;
  font-weight: 700;
  color: #303030;
  font-family: 'Inter', sans-serif;
`

export const Summary = styled.div`
  display: flex;
  gap: 32px;
  padding: 1rem;
`

export const SummaryItem = styled.div`
  flex: 1;
  display: flex;
  gap: 8px;
`

export const SummaryLabel = styled.span`
  font-family: 'Inter', sans-serif;
  color: #696969;
  white-space: nowrap;
`

export const SummaryValue = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  color: #303030;
  flex: 1;
`

export const Separator = styled.hr`
  border: none;
  height: 1px;
  background-color: #ebebeb;
`

export const ButtonsDiv = styled.div`
  display: flex;
  gap: 16px;
  padding: 1rem 0px;
  justify-content: end;
`

export const AddButton = styled.div`
  width: 13.9vw;
  height: 4.5vh;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  background-color: #0090d3;
`

export const AddButtonImg = styled.img`
  width: 0.8vw;
  height: 1.7vh;
  color: #ffffff;
`

export const AddButtonText = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #ffffff;
`

export const CancelButton = styled.button`
  width: 8vw;
  height: 4.5vh;
  border-radius: 20px;
  border: 1px solid #0090d3;
  cursor: pointer;
  background-color: #ffffff;
`

export const CancelButtonText = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #0090d3;
`

export const RemoveButton = styled.button`
  width: 9vw;
  height: 5.9vh;
  border-radius: 20px;
  border: 1px solid #fd7477;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  background-color: #ffffff;
`

export const RemoveButtontext = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #fd7477;
`

export const RemoveButtonImg = styled.img`
  width: 1vw;
  height: 2.6vh;
`